import nextAction from 'model/actions/utilities/nextAction';
/**
 * I continue my search.
 * Through the mountains, across the rivers.
 * The land is harsh, but I am relentless.
 * The bandits must be brought to justice.
 * I follow the tracks, the signs, the whispers of the land.
 * Until I reach their camp.
 * A small clearing, surrounded by trees, with a fire burning in the center.
 * I approach, cautiously. I draw my revolver.
 * I call out. They answer. I face them.
 *
 * The bandits. The murderers. The thieves.
 * I demand surrender. They refuse. I fire.
 * The shots echo in the night. The bandits fall. The fire flickers.
 * The smoke rises. The silence returns. I reload. I listen. I wait.
 * I hear no more. I lower my revolver.
 * I look at the bandits.
 * The blood stains the ground. The bodies lie still.
 * The eyes are open, but they do not see.
 * The souls have departed. I holster my revolver. I turn.
 * I walk away. The hunt is over.
 * Justice was here.
 * The trail is gone. I am alone.
 */

/**
 * I find the boy, huddled in a corner, clutching at his knees.
 * I approach him, slow and steady. He raises his head, eyes wide with fear.
 * I speak, gentle and low. He don't answer, just stares.
 * I reach out a hand, he flinches but don't move. I touch his shoulder, he shudders.
 * But he don't pull away. I lift him up, cradling him in my arms.
 * He don't resist. I carry him out, into the sunlight.
 * He don't speak, just clings to me. I take him to town, to the doctor.
 * The town doctor says he's unharmed. But he's traumatized.
 * He needs time. I sit with him, waiting. He don't talk, just cries.
 * I hold him, and I wait. Until he's ready.
 */

const search = onDone => ({
  title: 'The Bandits',
  description: [
    ` I find the boy, huddled in a corner, clutching at his knees.
 	 	 I approach him, slow and steady. He raises his head, eyes wide with fear.
 	 	 I speak, gentle and low. He don't answer, just stares.
 	 	 I reach out a hand, he flinches but don't move. I touch his shoulder, he shudders.
 	 	 But he don't pull away. I lift him up, cradling him in my arms.
 	 	 He don't resist. I carry him out, into the sunlight.
 	 	 He don't speak, just clings to me. I take him away.
		`
  ],
  buttons: [nextAction('Continue?', onDone)]
});

const approach = onDone => ({
  title: 'The Bandits',
  description: [
    `The bandits. The murderers. The thieves.
 	 	 I demand surrender. They refuse. I fire.
 	 	 The shots echo in the night. The bandits fall. The fire flickers.
 	 	 The smoke rises. The silence returns. I reload. I listen. I wait.
 	 	 I hear no more. I lower my revolver.
 	 	 I look at the bandits.
 	 	 The blood stains the ground. The bodies lie still.
 	 	 The eyes are open, but they do not see.
 	 	 The souls have departed. I holster my revolver. I turn.
 	 	 I walk away. The hunt is over.
 	 	 Justice was here.
 	 	 The trail is gone. I am alone.`
  ],
  buttons: [nextAction('Search', () => onDone(search(onDone)))]
});

const start = onDone => ({
  title: 'The Bandits',
  description: [
    `I continue my search.
 	 Through the mountains, across the rivers.
 	 The land is harsh, but I am relentless.
 	 The bandits must be brought to justice.
 	 I follow the tracks, the signs, the whispers of the land.
 	 Until I reach their camp.
 	 A small clearing, surrounded by trees, with a fire burning in the center.
 	 I approach, cautiously. I draw my revolver.
 	 I call out. They answer. I face them.`
  ],
  buttons: [nextAction('Approach', () => onDone(approach(onDone)))]
});

export default start;
